$(function () {
  var controller = null;
  function renderScrollMagic() {
    controller = new ScrollMagic.Controller();
    var tweenParams = {
      slideIn: {
        from: {y: window.innerHeight, ease:Linear.easeNone, immediateRender: true},
        to: {y: 0, ease:Linear.easeNone}
      },
      slideAway: {
        from: {y: 0, ease:Linear.easeNone},
        to: {y: -window.innerHeight * 1.1, ease:Linear.easeNone}
      }
    };
    var sections = $("section.active");
    $(".spacer").each(function( index ) {
      var index = $(this).data("index");
      if ( $( this ).hasClass("spacer--statement") ) {
        // Pull up the black band as well as the section after it.
        var scene = new ScrollMagic.Scene({
          triggerElement: this,
          duration: "110%",
          triggerHook: "onEnter"
        })
        // .addIndicators({name: `tandem ${index}/${index+1}`})
        var statementTween = TweenMax.fromTo([sections[index], sections[index + 1]], 1, tweenParams.slideIn.from, tweenParams.slideIn.to);
        scene.setTween(statementTween);
        scene.addTo(controller);
        scene.progress(0.0001);
      } else if ( $( this ).hasClass("spacer--reveal") ){
        // Then pull away black band, revealing the section below
        var scene = new ScrollMagic.Scene({
          triggerElement: this,
          duration: "100%",
          triggerHook: "onEnter"
        })
        // .addIndicators({name: `reveal ${index + 1}`})
        var revealTween = TweenMax.fromTo(sections[index], 1, tweenParams.slideAway.from, tweenParams.slideAway.to);
        scene.setTween(revealTween);
        scene.addTo(controller);
      } else {
        var scene = new ScrollMagic.Scene({
          triggerElement: this,
          duration: "100%",
          triggerHook: "onEnter"
        })
        // .addIndicators({name: `basic ${index}`})
        var basicTween = TweenMax.fromTo(sections[index], 1, tweenParams.slideIn.from, tweenParams.slideIn.to);
        scene.setTween(basicTween);
        scene.addTo(controller);
      }
    })
  }
  if (window.innerWidth >= 768 && !Modernizr.touch) {
    renderScrollMagic();
  } else {
    if ( navigator.userAgent.match('CriOS') ) {
      $("section").css("height", window.innerHeight + 60);
      var logoHeight = $("#landing-section .content").height();
      $("#landing-section .content").css("height", logoHeight);
      $("#bbf_map").css("height", function(){
        return $(this).height() + 60
      });
      $(".image-wrapper").css("height", function(){
        return $(this).height() + 15
      });
    };
  }
  var resizeTimer;
  $( window ).on("resize", function(e) {
    clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        if (window.innerWidth >= 768 && !Modernizr.touch) {
          renderScrollMagic();
        } else {
          if ( controller) {
            controller.enabled(false);
            $("section").not("#video-cover").removeAttr('style');
          }
        }
        map.fitBounds(bounds);
      }, 250);
  });
});